import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from '@one-thd/sui-atomic-components';
import { useLocation, useNavigate, useParams } from '@thd-olt-component-react/router';
import JobApplicants from '../../../pages/JobPostings/JobPostingPage/JobApplicants/JobApplicants';
import { JobPostingDetails } from '../../../pages/JobPostings/JobPostingPage/JobPostingDetails/JobPostingDetails';
import { RecommendedCandidates } from '../../../pages/JobPostings/JobPostingPage/RecommendedCandidates/RecommendedCandidates';
import { EXP_ROUTES } from '../../../utils/constants';
import TermsAndConditions from '../../common/TermsAndConditions/TermsAndConditions';
import { clickEvents } from '../../../utils/analytics';

export const TabNavigation = ({ jobPostingTitle }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { jobPostingId } = useParams();

  const [activeTabIndex, setActiveTabIndex] = useState(getTabFromPath(pathname));

  useEffect(() => {
    setActiveTabIndex(getTabFromPath(pathname));
  }, [pathname]);

  return (
    <div>
      <div className="p2p-tabs">
        <Tabs
          aria-label="main tabs"
          value={activeTabIndex}
        >
          <Tab
            label="Applicants"
            onClick={() => {
              clickEvents.jobApplicantsTabClick();
              navigate(EXP_ROUTES.JOB_APPLICANTS(jobPostingId));
            }}
          />
          <Tab
            label="Posting Details"
            onClick={() => {
              clickEvents.jobPostingDetailsTabClick(jobPostingTitle);
              navigate(EXP_ROUTES.JOB_POSTING(jobPostingId));
            }}
          />
          <Tab
            label="Recommended for You"
            onClick={() => {
              navigate(EXP_ROUTES.JOB_RECOMMENDED(jobPostingId));
            }}
          />
        </Tabs>
      </div>
      {activeTabIndex === 0 && (
        <JobApplicants
          goToRecommended={() => {
            setActiveTabIndex(2);
            navigate(EXP_ROUTES.JOB_RECOMMENDED(jobPostingId));
          }}
        />
      )}
      {activeTabIndex === 1 && <JobPostingDetails />}
      {activeTabIndex === 2 && <RecommendedCandidates />}
      <TermsAndConditions />
    </div>
  );

  function getTabFromPath(path) {
    if (path?.includes('applicants')) {
      return 0;
    }

    if (path?.includes('recommended')) {
      return 2;
    }

    return 1;
  }
};
